export default function getPageErrorData(code) {
  const data = []

  const figureData = {}
  figureData.url = `/images/static/${process.env.NEXT_PUBLIC_THEME}/404-bg.jpeg`
  figureData.alt = 'Page error image'
  figureData.image = {
    optimizedImageUrls: [
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/920x1080/404-bg.jpeg`,
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/1366x768/404-bg.jpeg`,
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/1024x576/404-bg.jpeg`,
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/640x360/404-bg.jpeg`,
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/320x180/404-bg.jpeg`
    ],
    optimizedWebPImageUrls: [
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/1920x1080/404-bg.jpg.webp`,
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/1366x768/404-bg.jpg.webp`,
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/1024x576/404-bg.jpg.webp`,
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/640x360/404-bg.jpg.webp`,
      `/images/static/${process.env.NEXT_PUBLIC_THEME}/320x180/404-bg.jpg.webp`
    ],
    variantSourceWidths: [1920, 1366, 1024, 640, 320],
    colorPalette: ['#202C6C', '#445297', '#3C4C8B', '#0E164B', '#444C8C']
  }
  data.figure = figureData

  if (code === 404) {
    data.text = 'PAGEERROR__LBL_404'

    const buttonData = {}
    buttonData.href = '/'
    buttonData.label = 'PAGEERROR__BTN_BACK'
    buttonData.icon = { id: 'icon-chevron-left', before: true }
    buttonData.modifiers = ['Button--pageError']
    data.button = buttonData
  } else if (code === 503) {
    data.text = 'PAGEERROR__LBL_503'
  } else if (code !== 404) {
    data.text = 'PAGEERROR__LBL_500'
  }

  return data
}
